import {
  USER_MANAGEMENT_SUCCESS,
  USER_MANAGEMENT_FAILED,
  LOADING_USER_MANAGEMENT,
  NETWORK_ERROR_USER_MANAGEMENT,
  RESET_USER_MANAGEMENT,
} from "../types/index";

import { partnerServices } from "../../config/axios";

const resetUserList = () => {
  return { type: RESET_USER_MANAGEMENT };
};

const getUserManagementList = (userData, authTokenIs) => async (dispatch) => {
  dispatch({ type: LOADING_USER_MANAGEMENT });
  await partnerServices
    .post("getUserManagementList", userData, { headers: { AuthToken: authTokenIs } })
    .then((res) => {
      switch (res.data.status) {
        case "success":
          dispatch(getUserManagementListsuccess(res.data));
          break;
        default:
          dispatch(getUserManagementListFailed(res.data));
          break;
      }
    })
    .catch((err) => {
      dispatch({ type: NETWORK_ERROR_USER_MANAGEMENT, payload: err });
    });
};

function getUserManagementListsuccess(data) {
  return {
    type: USER_MANAGEMENT_SUCCESS,
    payload: data,
  };
}
function getUserManagementListFailed(data) {
  return {
    type: USER_MANAGEMENT_FAILED,
    payload: data,
  };
}

export { resetUserList, getUserManagementList };
